// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_zud","cls2":"shared-cls2_Vka shared-cls1_zud"};